import { IPodcastDetailsDTO } from '@/modules/podcasts/dtos/podcast.dto';
import { IPodcastDetails } from '@/modules/podcasts/entities/podcast.entity';

export class PodcastDetailsMapper {
  public static toPresentation(podcastDetails: IPodcastDetailsDTO): IPodcastDetails {
    return {
      id: podcastDetails.id,
      name: podcastDetails.nome,
      thumbnail: podcastDetails.thumbnail,
      description: podcastDetails.descricao,
      episodeCount: podcastDetails.numeroDeEpisodios,
      role: {
        id: podcastDetails.cargo.id,
        name: podcastDetails.cargo.nome,
      },
    };
  }

  public static toDTO(podcastDetails: IPodcastDetails): IPodcastDetailsDTO {
    return {
      id: podcastDetails.id,
      nome: podcastDetails.name,
      thumbnail: podcastDetails.thumbnail,
      descricao: podcastDetails.description,
      numeroDeEpisodios: podcastDetails.episodeCount,
      cargo: {
        id: podcastDetails.role.id,
        nome: podcastDetails.role.name,
      },
    };
  }
}
